module.exports = __webpack_public_path__ + "img/hz12.7b4a3a8c.png";